/*=========================================================================================
  File Name: module-role-mutations.js
  Description: Role Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	Roles: [],
	RolesLoaded: false,
	Total: 0,
	IsLoadingTotalRecords: false,
	AllRoles: []
};
